module.exports = __webpack_public_path__ + "assets/img/logo-top40.24358fd4.webp";